import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import RootStoreContext from '~/contexts/RootStoreContext';
import { selectors as commonSelectors } from '~/domains/common';
import {
  selectors as agentScannersSelectors,
  actions as agentScannersActions
} from '~/domains/agentScanners';
import ScanAuditLog from './ScanAuditLog';

const mapStateToProps = (state, { match: { params } }) => {
  const scanners = agentScannersSelectors.scanners(state);
  const scanner = scanners.find((s) => s.id === params.scannerId);
  const profile = commonSelectors.profile(state);
  const organizationId = profile?.organization?.id;
  const scannerRuns = agentScannersSelectors.scannerRuns(state);
  const scannerRun = scannerRuns.find((s) => s.id === params.scanAuditLogId);
  const stagingAgents = agentScannersSelectors.stagingAgents(state);

  return {
    scanner,
    scannerId: params.scannerId,
    scanAuditLogId: params.scanAuditLogId,
    organizationId,
    isFetching: agentScannersSelectors.isFetchingScanners(state),
    scannerRun,
    isFetchingScannerRuns: agentScannersSelectors.isFetchingScannerRuns(state),
    stagingAgents,
    isFetchingStagingAgents:
      agentScannersSelectors.isFetchingStagingAgents(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadScannerRuns: (organizationId, scannerId, page, size) =>
    dispatch(
      agentScannersActions.loadScannerRuns(
        organizationId,
        scannerId,
        page,
        size
      )
    ),
  loadStagingAgents: (organizationId, scannerId, scanRunId, page, size) =>
    dispatch(
      agentScannersActions.loadStagingAgents(
        organizationId,
        scannerId,
        scanRunId,
        page,
        size
      )
    )
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, null, {
    context: RootStoreContext
  })
)(ScanAuditLog);
